{
  "pt": {
    "window": {
      "app": "Aplicação",
      "customersDashboard": "Painel de controlo",
      "customersDecisionDocuments": "Decisão",
      "customersDecisionProposals": "Propostas de decisão",
      "customersDecisionTickets": "Decisão",
      "customersDecisionTicketsShow": "Decisão",
      "customersDecisions": "Decisões",
      "customersDocuments": "Documentos",
      "customersDocumentsAll": "Síntese do documento",
      "customersDocumentsFolder": "Categoria do documento",
      "customersDocumentsFolders": "Categorias de documentos",
      "customersInspirationLists": "Inspirações",
      "customersInspirationListsShow": "Inspirações",
      "customersInstallmentTerms": "Prestações",
      "customersIssues": "Pós-venda",
      "customersIssuesList": "Pós-venda",
      "customersProjectInformation": "Informações sobre o projeto",
      "customersQuestionLists": "FAQs",
      "customersQuestionListsShow": "FAQs",
      "customersRoot": "Painel de controlo",
      "customersRootSettingsProfile": "Definições",
      "customersSettingsProfile": "Definições",
      "customersTickets": "Conversas",
      "customersTicketsNew": "Nova conversa",
      "customersTicketsShow": "Conversa",
      "employeesClientContacts": "Contactos",
      "employeesClientContactsNew": "Novo contacto",
      "employeesClientContactsNewCustomer": "Novo cliente",
      "employeesClientContactsNewPartner": "Novo parceiro",
      "employeesClientContactsType": "Contactos",
      "employeesClientDashboard": "Painel de controlo",
      "employeesClientProjects": "Projetos",
      "employeesClientProjectsNew": "Novo projeto",
      "employeesClientTickets": "Conversas",
      "employeesClientTicketsNew": "Nova conversa",
      "employeesClientTicketsShow": "Conversa",
      "employeesMarketplace": "Mercado",
      "employeesProjectActivity": "Atividade",
      "employeesProjectAnnouncements": "Feed de notícias",
      "employeesProjectDecisionActivity": "Atividade",
      "employeesProjectDecisionDocuments": "Decisão",
      "employeesProjectDecisionProposalTemplate": "Modelos de propostas",
      "employeesProjectDecisionProposals": "Propostas",
      "employeesProjectDecisionReminders": "Lembretes",
      "employeesProjectDecisionTickets": "Conversas",
      "employeesProjectDecisionTicketsShow": "Conversa",
      "employeesProjectDecisionTypeNew": "Nova decisão",
      "employeesProjectDecisionTypes": "Decisões",
      "employeesProjectDecisions": "Decisões",
      "employeesProjectDecisionsEdit": "Decisões",
      "employeesProjectDecisionsNew": "Nova decisão",
      "employeesProjectDocuments": "Documentos",
      "employeesProjectInformationPageActivity": "Atividade",
      "employeesProjectInformationPageAftercare": "Pós-venda",
      "employeesProjectInformationPageDecisions": "Decisões",
      "employeesProjectInformationPageDocuments": "Documentos",
      "employeesProjectInformationPageInformation": "Informações",
      "employeesProjectInformationPageInstallments": "Prestações",
      "employeesProjectInformationPageLevels": "Níveis",
      "employeesProjectInformationPageMilestones": "Marcos",
      "employeesProjectInformationPageSpaces": "Espaços",
      "employeesProjectInformationPageSurveys": "Inquéritos",
      "employeesProjectInformationPageTaskAssignments": "Tarefas",
      "employeesProjectInformationPageTasks": "Tarefas",
      "employeesProjectInformationPageTickets": "Conversas",
      "employeesProjectInstallmentGroup": "Finanças",
      "employeesProjectInstallmentGroupNew": "Nova fase de pagamento",
      "employeesProjectInstallmentGroups": "Finanças",
      "employeesProjectInstallmentGroupsList": "Finanças",
      "employeesProjectInstallmentGroupsMatrix": "Prestações",
      "employeesProjectInstallmentNew": "Novas prestações",
      "employeesProjectIssueListTypeIssues": "Lista de defeitos - Todos os defeitos",
      "employeesProjectIssueListTypeNew": "Nova lista de defeitos",
      "employeesProjectIssueListTypeUnits": "Lista de defeitos - Visão geral da unidade",
      "employeesProjectIssueListTypes": "Listas de defeitos",
      "employeesProjectIssueListUnitDocuments": "Defeitos na unidade - Documentos",
      "employeesProjectIssueListUnitIssues": "Defeitos na unidade",
      "employeesProjectIssueListUnitTickets": "Defeitos na unidade - Conversas",
      "employeesProjectIssueListUnitTicketsShow": "Conversas",
      "employeesProjectIssueListsNew": "Novos defeitos",
      "employeesProjectMilestones": "Marcos",
      "employeesProjectQuestionLists": "FAQs",
      "employeesProjectQuestionListsShow": "FAQ",
      "employeesProjectSalesUnits": "Vendas",
      "employeesProjectSurveySummary": "Inquérito",
      "employeesProjectSurveyTypes": "Inquéritos",
      "employeesProjectSurveys": "Inquérito",
      "employeesProjectTasks": "Tarefas",
      "employeesProjectTickets": "Conversas",
      "employeesProjectTicketsEmailConversations": "E-mails",
      "employeesProjectTicketsEmailConversationsShow": "E-mail",
      "employeesProjectTicketsNew": "Nova conversa",
      "employeesProjectTicketsShow": "Conversas",
      "employeesProjectTodoLists": "Tarefas",
      "employeesSettingsClientAftercare": "Pós-venda",
      "employeesSettingsClientInformation": "Administração",
      "employeesSettingsClientIntegrations": "Integrações",
      "employeesSettingsProfile": "Perfil",
      "level": "Nível",
      "mployeesProjectInstallmentGroups": "Finanças",
      "partnersClientProjects": "Projetos",
      "partnersProjectDecisionDocuments": "Documentos",
      "partnersProjectDecisionProposals": "Propostas",
      "partnersProjectDecisionTickets": "Conversas",
      "partnersProjectDecisionTicketsShow": "Conversa",
      "partnersProjectDecisionTypesItems": "Decisões",
      "partnersProjectDecisions": "Decisões",
      "partnersProjectDocuments": "Documentos",
      "partnersProjectDocumentsUnit": "Documentos",
      "partnersProjectIssueListTypeIssues": "Lista de defeitos - Todos os defeitos",
      "partnersProjectIssueListTypeUnits": "Lista de defeitos - Visão geral da unidade",
      "partnersProjectIssueListTypes": "Pós-venda",
      "partnersProjectIssueListUnitDocuments": "Defeitos na unidade - Documentos",
      "partnersProjectIssueListUnitIssues": "Defeitos na unidade",
      "partnersProjectIssueListUnitTickets": "Defeitos na unidade - Conversas",
      "partnersSettingsProfile": "Perfil",
      "root": "Aplicação"
    }
  }
}
